/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import APIManager from "../../../ApiManager/ApiManager";
import {
  GLOBAL_ADMIN_OVERVIEW_REQUEST,
  GLOBAL_ADMIN_OVERVIEW_SUCCESS,
  GLOBAL_ADMIN_OVERVIEW_FAILURE,
  FETCH_OVER_VIEW_DETAILS_REQUEST,
  FETCH_OVER_VIEW_DETAILS_SUCCESS,
  FETCH_OVER_VIEW_DETAILS_FAILURE,
  FETCH_OVER_VIEW_DETAILS_DOWNLOAD_REQUEST,
  FETCH_OVER_VIEW_DETAILS_DOWNLOAD_SUCCESS,
  FETCH_OVER_VIEW_DETAILS_DOWNLOAD_FAILURE,
  FETCH_GLOBAL_ADMIN_DOWNLOAD_SUCCESS,
} from "./GlobalAdminDashboardTypes";
import { COMMON_ERROR } from "../../ApplicationDetailsError/ApplicationDetailsErrorTypes";

export const fetchGlobalAdminDetailsRequest = () => {
  return {
    type: GLOBAL_ADMIN_OVERVIEW_REQUEST,
  };
};

export const fetchGlobalAdminOverViewDetailsSuccess = (overviewDetails) => {
  return {
    type: GLOBAL_ADMIN_OVERVIEW_SUCCESS,
    payload: overviewDetails,
  };
};

export const fetchGlobalAdminOverViewDetailsFailure = (error) => {
  return {
    type: GLOBAL_ADMIN_OVERVIEW_FAILURE,
    payload: error,
  };
};

export const fetchOverViewDetailsRequest = () => {
  return {
    type: FETCH_OVER_VIEW_DETAILS_REQUEST,
  };
};
export const fetchOverViewDetailsDownloadRequest = () => {
  return {
    type: FETCH_OVER_VIEW_DETAILS_DOWNLOAD_REQUEST,
  };
};

export const fetchOverViewDetailsSuccess = (overviewDetails) => {
  return {
    type: FETCH_OVER_VIEW_DETAILS_SUCCESS,
    payload: overviewDetails,
  };
};
export const fetchOverViewDetailsDownloadSuccess = (overviewDetails) => {
  return {
    type: FETCH_OVER_VIEW_DETAILS_DOWNLOAD_SUCCESS,
    payload: overviewDetails,
  };
};

export const fetchOverViewDetailsFailure = (error) => {
  return {
    type: FETCH_OVER_VIEW_DETAILS_FAILURE,
    payload: error,
  };
};
export const fetchOverViewDetailsDownloadFailure = (error) => {
  return {
    type: FETCH_OVER_VIEW_DETAILS_DOWNLOAD_FAILURE,
    payload: error,
  };
};
export const fetchGlobalAdminDownloadDetailsSuccess = (
  globalAdminDownloadData
) => {
  return {
    type: FETCH_GLOBAL_ADMIN_DOWNLOAD_SUCCESS,
    payload: globalAdminDownloadData,
  };
};

export const fetchGlobalAdminDetails = (requestBody) => {
  return async function (dispatch) {
    dispatch(fetchGlobalAdminDetailsRequest());
    try {
      const data = await APIManager.getGlobalAdminDetails(requestBody);
      dispatch(fetchGlobalAdminOverViewDetailsSuccess(data));
    } catch (error) {
      dispatch(fetchGlobalAdminOverViewDetailsFailure(error));
      dispatch(commonError(error, GLOBAL_ADMIN_OVERVIEW_FAILURE));
    }
  };
};

export const fetchGlobalAdminOverViewDetails = ({
  isAppListNeeded,
  isCountNeeded,
  isAppCountNeeded,
  offset,
  limit,
  searchText,
  requestBody,
}) => {
  return async function (dispatch) {
    dispatch(fetchOverViewDetailsRequest());
    try {
      const data = await APIManager.getGlobalAdminOverView(
        isAppListNeeded,
        isCountNeeded,
        isAppCountNeeded,
        offset,
        limit,
        searchText,
        requestBody
      );
      dispatch(fetchOverViewDetailsSuccess(data));
    } catch (error) {
      dispatch(fetchOverViewDetailsFailure(error));
    }
  };
};

export const fetchGlobalAdminOverViewDetailsDownload = ({
  isAppListNeeded,
  isCountNeeded,
  isAppCountNeeded,
  offset,
  limit,
  searchText,
  requestBody,
}) => {
  return async function (dispatch) {
    dispatch(fetchOverViewDetailsDownloadRequest());
    try {
      const data = await APIManager.getOverViewData(
        isAppListNeeded,
        isCountNeeded,
        isAppCountNeeded,
        offset,
        limit,
        searchText,
        requestBody
      );
      dispatch(fetchOverViewDetailsDownloadSuccess(data));
    } catch (error) {
      dispatch(fetchOverViewDetailsDownloadFailure(error));
    }
  };
};

export const globalAdminReportDetails = (requestBody) => {
  return async function (dispatch) {
    try {
      const data = await APIManager.getGlobalAdminDownloadDetails(requestBody);
      dispatch(fetchGlobalAdminDownloadDetailsSuccess(data));
    } catch (error) {
      dispatch(fetchGlobalAdminOverViewDetailsFailure(error));
      dispatch(commonError(error, GLOBAL_ADMIN_OVERVIEW_FAILURE));
    }
  };
};

export const commonError = (error, errorType) => {
  return {
    type: COMMON_ERROR,
    payload: {
      message: error.message,
      errorType: errorType,
    },
  };
};
